import React, { useMemo } from "react";
import { useRouteMatch } from "react-router-dom";
import PlaySVG from "../SVG/PlaySVG";
import CircleProgressBar from "../CircleProgressBar/CircleProgressBar";
import CheckSVG from "../SVG/CheckSVG";
import { LockIcon } from "../../../icons/Lock";
import CalendarSVG from "../SVG/CalendarSVG";
import * as cl from "../MainInfo/MainInfo.module.scss";
import AppLink from "../../../../../components/AppLink";

const CourseItem = ({ item, onNoAccessClick, isTitle, count }) => {
  const { url } = useRouteMatch();

  function handleClick() {
    if (item.available_on?.length) return;
    onNoAccessClick(item.access);
  }

  const [availableOnLable] = item.available_on.split(',');

  const content = useMemo(() => {
    if (isTitle) {
      return (
        <>
          {!!count && <span className={cl.lessons__count}>{count}.</span>}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              marginRight: "20px",
              alignItems: "center",
            }}
          >
            <div
              style={{ display: "flex", width: "100%", alignItems: "center" }}
            >
              <i style={{ marginRight: "12px" }}>
                {item.has_access ? <PlaySVG /> : <LockIcon color="#8898AE" />}
              </i>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginRight: "12px",
                  alignItems: "center",
                }}
              >
                <div dangerouslySetInnerHTML={{ __html: item.title }} />
                <div>
                  {!item.has_access && item.available_on && (
                    <div className={cl.available}>
                      <CalendarSVG />
                      {availableOnLable}
                    </div>
                  )}
                  {!!item.video_length && (
                    <div className={cl.videoLenght}>{item.video_length}</div>
                  )}
                </div>
              </div>
            </div>
            {item.progress ? (
              <i className={cl.done}>
                <CheckSVG />
              </i>
            ) : (
              <CircleProgressBar />
            )}
          </div>
        </>
      );
    }
    return (
      <>
        <i>{item.has_access ? <PlaySVG /> : <LockIcon color="#8898AE" />}</i>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: item.title }} />
          <div className={cl.box}>
            {!item.has_access && item.available_on && (
              <div className={cl.available}>
                <CalendarSVG />
                {availableOnLable}
              </div>
            )}
            {!!item.video_length && (
              <div className={cl.videoLenght}>{item.video_length}</div>
            )}
          </div>
        </div>
        {item.progress ? (
          <i className={cl.done}>
            <CheckSVG />
          </i>
        ) : (
          <CircleProgressBar />
        )}
      </>
    );
  }, [item, isTitle, count, availableOnLable]);

  return item.has_access && !item.available_on ? (
    <AppLink
      to={`${url}${item.post_name}/`}
      className={isTitle ? cl.lessons__lessonTitle : cl.lessons__lessonItem}
    >
      {content}
    </AppLink>
  ) : (
    <div
      onClick={handleClick}
      className={isTitle ? cl.lessons__lessonTitle : cl.lessons__lessonItem}
    >
      {content}
    </div>
  );
};

export default CourseItem;
